import React, {useState, useEffect} from "react"
import Styles from "./PricingModul.scss"
import Icon from "@mdi/react";
import {mdiCheck, mdiClose, mdiLoading} from "@mdi/js";
import {connect} from "react-redux";



const PricingModule = ( { selected, options, pricing, setCurrentCenterPage})=>{



    useEffect(()=>{

    }, [])


    const handleClick = ()=>{
        setCurrentCenterPage("contact");
    }

    const renderOption = (item,index)=>{
        return <div key={index} className={"ue-pricing-module-options-item"}>
            {(pricing?.options[index]?.val)?
                <Icon path={mdiCheck} size={1} color={'#7dbd39'} />
                :<Icon path={mdiClose} size={1.1} color={'#af3710'} />
            }
                <div className={"ml-2"}>{pricing?.options[index]?.nb} {item.label}</div>
                </div>
    }


    return ( <div className={`d-flex flex-column justify-content-between align-items-center align-self-stretch  w-100 ue-pricing-module ${selected?"active":null}`}>
            <div className={"ue-pricing-module-ref"}>{pricing.ref} <sup>*</sup></div>
        {(pricing.price)?<div className={"ue-pricing-module-price"}>
                <div className={"price"}><span className={"money"}>€</span>{pricing.price}</div>
                <div>TTC /{pricing.period}</div>
            </div>
            :<div className={"ue-pricing-module-price"}><div className={"price"}>Nous<br/>Contacter</div></div>
        }
            <div className={"ue-pricing-module-subtitle"}>{pricing.subtitle}</div>
            <div className={"ue-pricing-module-options"}>
                {(options?.length)?
                    options.map((item,index)=> renderOption(item,index))
                    :null
                }
            </div>
            {(!selected)?
                <div id={"ue-btn-pricing-module"} className={"btn btn-lg btn-outline-primary  text-center mt-3"}
                     onClick={handleClick}
                >
                    Nous contacter
                </div>
                : <div id={"ue-btn-pricing-module"} className={"btn btn-lg btn-outline-light text-light text-center mt-3"}
                       onClick={handleClick}
                >
                    Nous contacter
                </div>
            }

            </div>
    )

}

const mapStateToProps = (state) => {
    return {
        userId: state.MeReducer.id,
        entity: state.MeReducer.entity,
        email: state.MeReducer.email,
        name: state.MeReducer.name,
        username : state.MeReducer.username,
        structureInfo: state.SubscribtionReducer.structureInfo,
    }
}


const mapDispatchTProps = (dispatch) => {
    return {
        updateStructureInfo: (e) => dispatch({type: 'UPDATE_STRUCTURE_INFO', data: e}),
        updateUserInfo: (e) => dispatch({type: 'UPDATE_USER_STATUS', data: e}),
        setCurrentCenterPage: (e) => dispatch({type: 'SET_CURRENT_PAGE', data: e}),
    }
}


export default connect(mapStateToProps, mapDispatchTProps)(PricingModule);
